import { EditorState } from 'draft-js';

const getSelectedBlocksMap = (editorState: EditorState) => {
    const selectionState = editorState.getSelection();
    const contentState = editorState.getCurrentContent();
    const startKey = selectionState.getStartKey();
    const endKey = selectionState.getEndKey();
    const blockMap = contentState.getBlockMap();
    return blockMap
        .toSeq()
        .skipUntil((_, k) => k === startKey)
        .takeUntil((_, k) => k === endKey)
        .concat([[endKey, blockMap.get(endKey)]]);
};

export const getSelectedBlocksList = (editorState: EditorState) => getSelectedBlocksMap(editorState).toList();

export const getSelectionText = (editorState: EditorState) => {
    let selectedText = '';
    const currentSelection = editorState.getSelection();
    let start = currentSelection.getAnchorOffset();
    let end = currentSelection.getFocusOffset();
    const selectedBlocks = getSelectedBlocksList(editorState);
    if (selectedBlocks.size > 0) {
        if (currentSelection.getIsBackward()) {
            const temp = start;
            start = end;
            end = temp;
        }
        for (let i = 0; i < selectedBlocks.size; i += 1) {
            const blockStart = i === 0 ? start : 0;
            const blockEnd = i === selectedBlocks.size - 1 ? end : selectedBlocks.get(i).getText().length;
            selectedText += selectedBlocks.get(i).getText().slice(blockStart, blockEnd);
        }
    }
    return selectedText;
};

export const getLinkTarget = (editorState: EditorState) => {
    const contentState = editorState.getCurrentContent();
    const startKey = editorState.getSelection().getStartKey();
    const startOffset = editorState.getSelection().getStartOffset();
    const blockWithLinkAtBeginning = contentState.getBlockForKey(startKey);
    const linkKey = blockWithLinkAtBeginning.getEntityAt(startOffset);

    if (linkKey) {
        const linkInstance = contentState.getEntity(linkKey);
        // eslint-disable-next-line prefer-destructuring
        return linkInstance.getData().url;
    }

    return '';
};
